export const getArticleMicrodata = (
  {
    headline,
    imageUrl,
    datePublished
  }) => {
  return {
    '@type': 'Article',
    'headline': headline,
    'image': imageUrl,
    'datePublished': datePublished,
    'author': {
      '@type': 'Organization',
      'name': 'Dnipro-M'
    },
    'publisher':
      [
        {
          '@type': 'Organization',
          'name': 'Dnipro-M',
          'url': window.location.protocol + '//' + window.location.hostname
        }
      ]
  }
}
